import { FormArray, FormControl, FormGroup } from '@angular/forms';

type Flatten<Type> = Type extends Array<infer Item> ? Item : Type;

export class TypedFormArray<T> extends FormArray<FormControl<T> | TypedFormGroup<T>> {}

export type TypedForm<T> = {
  [K in keyof T]: T[K] extends Array<any>
    ? TypedFormArray<Flatten<T[K]>> | FormControl<T[K]>
    : FormControl<T[K]> | FormGroup<TypedForm<T[K]>>;
};

export class TypedFormGroup<T> extends FormGroup<TypedForm<T>> {}

/*
export type ModelFormGroup<T> = FormGroup<{


  [K in keyof T]:   FormControl<T[K]>;
}>;

export type ModelFormArray<T> = FormArray<
  FormGroup<{
    [K in keyof T]: FormControl<T[K]>;
  }>
>;

export type ControlsOf<T extends Record<string, any>> = {
    [K in keyof T]: T[K] extends Record<any, any>
    ? FormGroup<ControlsOf<T[K]>>
    : FormControl<T[K]>;
  };

  function create<T>(ctor: { new(): T }) {
    return new ctor();
  }
  var c = create(MyClass); // c: MyClass

  function isReallyInstanceOf<T>(ctor: { new(...args: any[]): T }, obj: T) {
    return obj instanceof ctor;
  }

  */
/* ALETRANATIVA
 //https://stackoverflow.com/questions/75190697/angular-14-strictly-typed-reactive-forms-using-generics
  export type TypedFormControls<T extends Record<any, any>> = {
    [K in keyof T]-?: T[K] extends Array<infer R>
      ? FormArray<R extends Record<any, any> ? FormGroup<TypedFormControls<R>> : FormControl<R>>
      : T[K] extends Record<any, any>
      ? FormGroup<TypedFormControls<T[K]>>
      : FormControl<T[K]>;
  };
  */
